import React from 'react'
import { CustomColumnHeaderRenderer } from '../../legacy-design-system/grid'
import {
  DateRangePicker,
  DateRangePickerDropdown,
  DateRangeOption
} from '../../legacy-design-system/date-picker'
import { DateRange } from '../../legacy-design-system/date-picker/shared'

export interface LastActivityColumnArgs {
  readonly dateRange?: DateRange
  readonly dateRangeOption?: DateRangeOption
  readonly onSetCustomDateRange: (dateRange: DateRange) => void
  readonly onSetDateRangeOption: (dateRangeOption: DateRangeOption) => void
  readonly onClearDateRange: () => void
}

export function getLastActivityHeaderRenderer({
  dateRange,
  dateRangeOption,
  onSetCustomDateRange,
  onSetDateRangeOption,
  onClearDateRange
}: LastActivityColumnArgs): CustomColumnHeaderRenderer<never> {
  return ({ renderContent }) => {
    return (
      <DateRangePickerDropdown
        selectedDateRange={dateRange}
        selectedOption={dateRangeOption}
        onDateRangeOptionSelect={onSetDateRangeOption}
        onCustomDateRangeSelect={onSetCustomDateRange}
        renderToggle={({ getToggleButtonProps, isOpen, selectedItem }) => {
          return (
            <div {...getToggleButtonProps()}>
              {renderContent({
                isClickable: true,
                isOpen,
                isFilterable: true,
                isFiltered:
                  selectedItem !== undefined && dateRange !== undefined,
                onClear: onClearDateRange
              })}
            </div>
          )
        }}
        renderDateRangePicker={(props) => <DateRangePicker {...props} />}
      />
    )
  }
}
